import React from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { getPositionStats } from "../utils/tradeStats";

const formatMetricValue = (value, decimals = 2, prefix = "", suffix = "") => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return `${prefix}0${suffix}`;
  }
  return `${prefix}${numericValue.toFixed(decimals)}${suffix}`;
};

const AccountInfo = ({ accountInfo = {}, allTradePositions = [], allTradesStartingAmount = 0, cashflows = [] }) => {
  const allTradeStats = getPositionStats(allTradePositions, accountInfo, allTradesStartingAmount, cashflows);
  const summaryCards = [
    { label: "Deposited", value: formatMetricValue(accountInfo.deposited, 2, "£") },
    { label: "Balance", value: formatMetricValue(accountInfo.balance, 2, "£") },
    { label: "Equity", value: formatMetricValue(accountInfo.equity, 2, "£") },
    { label: "% Gained", value: formatMetricValue(allTradeStats.percentage_gain, 2, "", "%") },
    {
      label: "Max Drawdown",
      value: formatMetricValue(allTradeStats.max_drawdown_percent, 2, "", "%"),
    },
    { label: "Win Ratio", value: formatMetricValue(allTradeStats.win_ratio, 2, "", "%") },
  ];

  return (
    <Card className="app-widget-panel shadow-sm dashboard-summary-card">
      <CardBody>
        <CardTitle tag="h5" className="app-widget-title">
          Account Overview
        </CardTitle>
        <Row className="g-3 app-widget-grid">
          {summaryCards.map((metric) => (
            <Col xs={6} md={6} xl={4} key={metric.label} className="app-widget-grid__col">
              <div className="app-metric-card">
                <span className="app-metric-label">{metric.label}</span>
                <span className="app-metric-value">{metric.value}</span>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default AccountInfo;
